import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content"];

  show() {
    if (this.showTimeout) return;
    this.showTimeout = setTimeout(() => {
      this.contentTarget.classList.remove("hidden");
    }, 300);
  }

  hide() {
    clearTimeout(this.showTimeout);
    this.showTimeout = null;
    this.contentTarget.classList.add("hidden");
  }
}
